import dayjs from "dayjs";

export const stockOverviewPrint = (
  data,
  selectedTab,
  selectedClient,
  selectedProduct,
) => {
  const grand_total = data?.reduce((a, c) => a + c.amount, 0);
  const total_weight = data?.reduce((a, c) => a + c.weight, 0);

  return `
        <!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <link
      rel="stylesheet"
      href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.0/css/all.min.css"
    />
    <title>${
      selectedClient ? data?.[0].client_name + " - " : "Semua Client - "
    }Stock Overview</title>
    <style>
      body {
        font-family: Arial, sans-serif;
        position: relative;
        font-size: 10px;
      }
      table {
        width: 100%;
        border-collapse: collapse;
        margin-top: 5px;
      }
      table,
      th,
      td {
        border: 1px solid black;
        text-align: center;
        padding: 3px;
      }
      tr:nth-child(even) {
        background-color: #f2f2f2;
      }
      body::before {
        content: "";
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background-image: url("/logo.png");
        background-repeat: no-repeat;
        background-position: center;
        background-size: 80%;
        opacity: 0.08;
        z-index: 0;
        transform: rotate(-30deg);
        pointer-events: none;
      }
    </style>
  </head>
  <body>
    <div style="text-align: center">
      <h2>WMS ELBE GROUP</h2>
      <h2>STOCK OVERVIEW</h2>
    </div>
    <div>
      <p style="font-weight: bold">${
        selectedTab === "Product" ? "Jenis Produk: " : "Nama Client: "
      }<span>${
        selectedTab === "Product"
          ? selectedProduct
            ? data?.[0]?.product_name
            : "Semua Produk"
          : selectedClient
            ? data?.[0].client_name
            : "Semua Client"
      }</span></p>
  <p>
    Tanggal Cetak: ${dayjs().format("DD-MM-YYYY HH:mm:ss")}
  </p>
    </div>
    <div>
      <table>
        <thead>
          <tr style="background-color: #3e8600; color: white">
            <th>No</th>
            <th>${
              selectedTab === "Product" ? "Nama Client" : "Jenis Produk"
            }</th>
            <th>No. Pallet</th>
            <th>Posisi</th>
            <th>Berat</th>
            <th>Spesifikasi</th>
            <th>Tanggal Inbound</th>
            <th>Lama Penyimpanan</th>
            <th>Jumlah Pack</th>
            <th>Total Biaya</th>
          </tr>
        </thead>
        <tbody>
        ${data
          ?.map(
            (item) =>
              `     
            <tr>
              <td>${item?.no}</td>
              <td>${
                selectedTab === "Product"
                  ? item?.client_name
                  : item?.product_name
              }</td>
              <td>${item?.pallet_name}</td>
              <td>${item?.name}</td>
              <td>${Math.round(item?.weight)} Kg</td>
              <td>${item?.specification ?? "-"}</td>
              <td>${
                item?.received_at
                  ? dayjs(item?.received_at).format("DD-MM-YYYY")
                  : "-"
              }</td>
              <td>${item?.duration}</td>
              <td>${item?.quantity}</td>
              <td>Rp ${item?.amount?.toLocaleString("id-ID")}</td>
            </tr>
            `,
          )
          .join("")}
          <tr style="background-color: white">
            <td colspan="4" style="font-weight: bold">Total</td>
            <td style="font-weight: bold">${Math.round(total_weight).toLocaleString("id-ID")} Kg</td>
            <td colspan="4"></td>
            <td style="font-weight: bold">Rp ${grand_total.toLocaleString(
              "id-ID",
            )}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div style="
      page-break-after: always;
      position: fixed;
      bottom: -10;
      left: 0;
      right: 0;
      text-align: center;
    ">
      <h2>
        Customer Service:&nbsp;&nbsp;&nbsp;
        <i class="fab fa-whatsapp"></i> 081225151232&nbsp;&nbsp;&nbsp;
        <i class="fas fa-globe"></i> https://www.lautanberkatfood.com/&nbsp;&nbsp;&nbsp; 
        <i class="fas fa-envelope"></i> lautanberkatfood@gmail.com&nbsp;&nbsp;&nbsp;
      </h2>
    </div>
  </body>
</html>
    `;
};
